const FAQ_ITEMS = [
  {
    q: '6080电影网是否需要注册或付费？',
    a: '完全免费，无需注册即可畅享全部高清电影资源。6080电影网始终坚持开放共享理念，所有影片均可直接在线观看，不设任何付费门槛，无隐藏消费，也无须绑定手机号，打开网页即可开始观影。',
  },
  {
    q: '视频加载慢或卡顿怎么办？',
    a: '本站采用全球CDN智能加速与多线BGP节点分发技术，系统会根据您的网络环境自动匹配最优节点，确保极速秒开不缓冲。如遇卡顿，可尝试切换清晰度或刷新页面，通常可立即解决。',
  },
  {
    q: '支持哪些设备观看电影？',
    a: '全面兼容PC、平板、手机等主流设备，自适应屏幕尺寸，横屏竖屏均可流畅播放。无论您是Windows、macOS、iOS还是Android用户，打开浏览器访问6080电影网即可获得一致的高清观影体验。',
  },
  {
    q: '影片更新频率如何？最新电影什么时候上线？',
    a: '内容团队每日持续更新，平均每日上线100+部高清影片，涵盖最新院线下映大片、热门剧集、经典老片和纪录片。新片通常在院线下映后的第一时间完成上线，力争让您最快看到想看的电影。',
  },
  {
    q: '画质怎么样？支持超清播放吗？',
    a: '全线提供高清及以上画质，大部分影片支持1080P全高清播放，热门大片和经典影片更提供4K超清选项。所有片源均经过转码优化，在保证清晰度的同时控制文件大小，兼顾画质与加载速度。',
  },
];

const COMMENTS = [
  {
    name: '光影追逐者',
    time: '2小时前',
    content: '用了两年多了，片源更新速度真的快，基本想看的都能找到。画质高清不卡顿，比那些到处弹广告的网站强太多了，真心推荐给喜欢看电影的朋友！',
    tag: '资深用户',
  },
  {
    name: '周末影院',
    time: '昨天 18:42',
    content: '每周末都会打开6080挑几部电影看，分类清晰找片方便。高清画质配合大屏投影，家庭影院体验拉满。最关键的是没有广告打断，观影沉浸感非常好。',
    tag: '忠实观众',
  },
  {
    name: '追剧小达人',
    time: '昨天 14:15',
    content: '之前在其他平台看个电影要等几十秒广告，遇到6080之后再也回不去了。手机端体验也很棒，上下班地铁上追剧看电影，流量消耗也不大，强烈安利！',
    tag: '新用户',
  },
  {
    name: '电影收藏家',
    time: '前天 21:30',
    content: '作为一个收藏了上千部电影的老影迷，6080的资源库深度确实让我惊喜。很多冷门老片和独立电影都能找到，画质还都很不错，已经推荐给身边所有喜欢电影的朋友了。',
    tag: '影迷达人',
  },
];

const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '极速秒开',
    desc: '全球CDN加速节点覆盖，智能路由匹配最优线路，打开即播无需等待，告别加载转圈和缓冲焦虑。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全线1080P全高清起步，热门大片支持4K超清，每一帧都清晰锐利，为您呈现影院级视觉享受。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '10万+影片持续更新，覆盖动作、喜剧、科幻、爱情等全品类，每日新增100+，发现不停歇。',
  },
];

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          关于6080电影网的使用，这里有你想要的答案
        </p>
        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-lg border border-background-200" open={i === 0}>
              <summary className="cursor-pointer flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors select-none">
                <span className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold flex-shrink-0">
                    {i + 1}
                  </span>
                  {item.q}
                </span>
                <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <div className="px-5 pb-4 pl-14 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          听听真实用户怎么说
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {COMMENTS.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 border border-background-200">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">{item.name[0]}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.name}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-1 mt-2 text-accent-400">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          为什么选择6080电影网
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-6 border border-background-200 text-center group hover:border-primary-200 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}